<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} una Institucion</option>
        <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" value="value">{{enumeraciones.tiposDeSelect.Todos.Nombre}} las Instituciones</option>
        <option v-for="Autoridad in Autoridades" :value="Autoridad.AutoridadID">{{Autoridad.Nombre}}</option>
      </select>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import {mapActions} from 'vuex'
  import axios from 'axios'

  export default
  {
    data(){
      return {
        enumeraciones,
        comun,
        Autoridades:[],
        idDelModelo: -1
      }
    },//Data
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
    },//Props
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerAutoridad", { llave: this.idDelInput, valor: this.idDelModelo });
    },
    methods: {
    CargarCatalogoDeAutoridades(){
      let peticion = {
        EsPrueba: comun.EsPrueba,
        TipoInst: this.$store.state.TemisCivil_Catalogos_TipoInstitucionNombre.valor,
        Municipio: this.$store.state.TemisCivil_Catalogos_MunicipioAbreviatura.valor
      }
      axios.post(api.conexion + api.TemisCivil.catalogos.Autoridades, peticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              if(respuesta.data._Autoridades.length > 0)
              {
                this.Autoridades = respuesta.data._Autoridades;
                //Seleccionar la primer Autoridad n_n
                this.idDelModelo = this.Autoridades[0].AutoridadID;
                this.cambiaAutoridadInicial(this.Autoridades[0].Nombre);
              }
              return respuesta.data._Autoridades;
            }
          }).catch(e => {
            console.log(e);
         });
    },//CargarCatalogoDeTramites
    cambiarDatos(evento) {
      this.idDelModelo = evento.target.value;
      this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerAutoridad", { llave: this.idDelInput, valor: evento.target.value });
      this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerNombreAutoridad", { llave: this.idDelInput, valor: evento.target.selectedOptions[0].innerText});
      this.$emit("valorParaElPadre", evento);
    },
    cambiaAutoridadInicial: function(nombre_aGuardar){
      this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerAutoridad", { llave: this.idDelInput, valor: this.idDelModelo});
      this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerNombreAutoridad", { llave: this.idDelInput, valor: nombre_aGuardar});
      this.$emit("valorParaElPadre", this.idDelModelo);
    }
    },//Methods
    created() {
      this.CargarCatalogoDeAutoridades();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/TemisCivil/Catalogos/Autoridades.vue